__turbopack_context__.v({
  "badge": "index-module-scss-module__TX8OlW__badge",
  "badgeIcon": "index-module-scss-module__TX8OlW__badgeIcon",
  "container": "index-module-scss-module__TX8OlW__container",
  "shortModal": "index-module-scss-module__TX8OlW__shortModal",
});
